<script setup lang="ts">
import CSInputText from '@/onenetwork/components/form/CSInputText.vue';
import LoginLayout from '@/onenetwork/layouts/LoginLayout.vue';
import { useAuthStore } from '@/onenetwork/stores/onenetwork.store.auth.ts';
import { Icon } from '@iconify/vue';
import { yupResolver } from '@primevue/forms/resolvers/yup';
import { useToast } from 'primevue/usetoast';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as yup from 'yup';

const authStore = useAuthStore()

const toast = useToast();
const initialValues = ref({
  phone_number: '',
  password: '',
});

const router = useRouter()
const route = useRoute();
const formRef = ref<any>(null);

const schemaYup = yup.object().shape({
  phone_number: yup.string().required('Số điện thoại không được để trống').min(10, 'Số điện thoại phải có 10 chữ số'),
});

const resolver = yupResolver(schemaYup);

const loading = ref(false)

const onFormSubmit = ({values, valid}: any) => {
  if(!valid) return;
  try{
    loading.value = true
    authStore.checkPhoneExist(values.phone_number).then((res) => {
      setTimeout(() => {
        loading.value = false
        router.push({
          path: '/auth/verify-otp',
          query: {
            phone_number: values.phone_number
          }
        });
      }, 1000)
    })
    .catch((e: any) => {
      loading.value = false
      toast.add({ severity: 'error', summary: 'Số điện thoại không tồn tại', detail: `Số điện thoại không tồn tại, vui lòng thử lại`, life: 2000 });
    })
  } catch (e) {
    loading.value = false
    toast.add({ severity: 'error', summary: 'Số điện thoại không tồn tại', detail: `Số điện thoại không tồn tại, vui lòng thử lại`, life: 2000 });
  }

};
</script>

<template>
<div class="auth-page flex w-[100vw] h-[100vh] flex-col md:flex-row items-center">
  <LoginLayout />
  <div class="flex flex-1 h-[100vh] p-5 justify-center flex-col px-[16px]">
    <Form v-slot="$form"
          :initial-values="initialValues"
          ref="formRef"
          :resolver="resolver"
          @submit="onFormSubmit" class="w-full md:w-[20vw] mx-auto ">
      <h3 class="font-bold text-xl mb-3">Lấy lại mật khẩu</h3>
      <p class="text-[12px] mb-3">Để khôi phục mật khẩu vui lòng xác minh số điện thoại mà bạn đã đăng ký trên hệ thống OneNetwork</p>
      <div class="flex flex-col mb-3">
        <div class="flex-1 text-[12px] mb-1">Số điện thoại:</div>
        <div class="flex-1">
          <CSInputText
            :model-value="initialValues?.phone_number"
              name="phone_number"
              type="text"
              class="form-control"
              maxlength="10"
              @keypress="(e) => {
                const charCode = (e.which) ? e.which : e.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                  e.preventDefault();
                }
              }"
              @paste="(e: ClipboardEvent) => {
                e.preventDefault();
                const text = e.clipboardData?.getData('text') || '';
                const numbers = text.replace(/\D/g, '').slice(0, 10);
                formRef.value?.setFieldValue('phone_number', numbers);
              }"
            />
          <Message v-if="$form.phone_number?.invalid" severity="error"  variant="simple">{{ $form?.phone_number?.error?.message }}</Message>
        </div>
      </div>
      <div class="flex justify-between items-center">
        <Button type="submit" class="px-[40px] py-[10px] bg-[#ff6f00] text-white hover:bg-[#1E88E5] cursor-pointer" :disabled="loading">
          Gửi mã xác thực <Icon icon="eos-icons:three-dots-loading" v-if="loading" />
        </Button>
        <div class="!ml-5">
          <router-link to="/auth/login" class="hover:text-slate-700 text-[12px]">Quay về đăng nhập</router-link>
        </div>
      </div>
    </Form>
    <br/>
    <br/>
    <br/>
  </div>
</div>
</template>

<style scoped>

</style>
